import styled from '@emotion/styled';
import { Modal, Button, Timeline } from 'antd';
import type { ButtonProps } from 'antd';

/**
 * Modal高度不大于屏幕高度的一定范围
 */
export const JustRightHeightModal = styled(Modal)`
  .${({ theme }) => theme.getAntdPrefixedClassName('modal-body')} {
    overflow-y: auto;
    margin: var(--fett-right-height-modal-scroll-body-margin);
    &:nth-last-of-type(2) {
      max-height: calc(94vh - 108px);
    }
    &:nth-last-of-type(1) {
      max-height: calc(94vh - 55px);
    }
  }
`;

/**
 * dashed button
 */
const DashedButtonImpl = styled(Button)`
  border-color: var(--ant-primary-color);
  color: var(--ant-primary-color);
`;

export const DashedButton = (props: ButtonProps) => {
  return <DashedButtonImpl type="dashed" {...props} />;
};

/**
 * simple timeline
 */
export const TimelineWrapper = styled(Timeline)`
  .ant-timeline-item-tail {
    border-left: 2px dotted var(--fett-border-default);
  }
  .ant-timeline-item-head {
    border-color: var(--fett-border-default);
    color: #f0f0f0;
    width: 8px !important;
    height: 8px !important;
    left: 1px;
    top: 1px;
    background: #f0f0f0;
  }
`;
